export const ReplyType = {
  Chatbot: 'Chatbot',
  PromoteInputFeedback: 'PromoteInputFeedback',
  Agent: 'Agent',
};

const isReplyTypeEqual = (target) => (replyType) => replyType === target;

export const isChatbotReply = isReplyTypeEqual(ReplyType.Chatbot);

export const isPromoteInputFeedbackReply = isReplyTypeEqual(
  ReplyType.PromoteInputFeedback,
);

export const isAgentReply = isReplyTypeEqual(ReplyType.Agent);
